

import Vue from 'vue';
import { Component, Model, Prop, Watch } from 'vue-property-decorator';
import { AppNavLinks } from '@/business/settings'
import { NavLink, BreadcrumbItem } from '@/models/types';
import moment from 'moment';
import { tUi } from '@/utils/translate';

@Component({
    name: 'RepsolBreadcrumbComponent',
    components: {}
})

export default class RepsolBreadcrumbComponent extends Vue {

    list: BreadcrumbItem[] = [];

    constructor(){
        super();
    }

    mounted(){
        this.fillBreadCrumb();
    }

    @Watch('$route')
    reloadBreads(from, to) {
        this.fillBreadCrumb();
    }

    @Watch('$i18n.locale')
    reloadLocale() {
        this.fillBreadCrumb();
    }


    fillBreadCrumb() : void {
        this.list.splice(0);
        let position = -1;
        let find = false;

        while(!find){
            const currentMatch  =this.$route.matched.at(position);
            if(!currentMatch)
                return;

            const currentPath = currentMatch.path;
            for (let i = 0; i < AppNavLinks.length; i++) {
                if(this.fillBreadCrumbChilds( AppNavLinks[i], currentPath)){
                    find =true;
                    break;
                }
            }
            position--;
        }
    }

    fillBreadCrumbChilds(appNavLink: NavLink, currentPath:string) : boolean{
        let find = false;
        if(appNavLink.path.toLowerCase() == currentPath.toLowerCase()){
            find  =true;
        } else if(appNavLink.children) {
            for (let i = 0; i < appNavLink.children.length; i++) {
                const childAppNavLink = appNavLink.children[i];
                if(this.fillBreadCrumbChilds(childAppNavLink, currentPath)){
                    find  =true;
                    break;
                }
            }
        }

        if(find){
            this.list.unshift({
                text: tUi(appNavLink.name),
                disabled: true,
                href: appNavLink.path
            });
        }
        return find;
    }
}

Vue.component('repsol-breadcrumb', RepsolBreadcrumbComponent);
